import React from "react";
import { ReactComponent as WarningTriangleIcon } from "../../../assets/icons/warning_triangle.svg";

interface IconWarningTriangleProps {
  size?: number;
}

const IconWarningTriangle: React.FC<IconWarningTriangleProps> = ({
  size = 48,
}) => (
  <WarningTriangleIcon width={size} height={size} style={{ flexShrink: 0 }} />
);

export default IconWarningTriangle;
